export const selectJobsList = (state) =>
  state.jobs.jobs;

export const selectJobsLoading = (state) =>
    state.jobs.loading;

export const selectCurrentJob = (state) => state.jobs.currentJob;
export const selectCountries = (state) => state.jobs.countries;
export const selectJobFilter = (state) => state.jobs.filters;